export const scrollToStory = (storyId: string, behavior: ScrollBehavior = 'instant') => {
  document.querySelector(`#story_${storyId}`)?.scrollIntoView({
    behavior,
    block: 'start',
  })
}
